export default "__VITE_ASSET__83beaf1a__"